module.exports = __webpack_public_path__ + "img/banner3.00b3171d.png";